import { Outlet } from "react-router-dom";
import { ZikrList } from "./ZikrList";
import ZikrForm from "./ZikrForm";

export const ZikrRoutes = [
  {
    path: "zikrs",
    element: Outlet,
    children: [
      {
        path: "",
        element: ZikrList,
      },
      {
        path: "add",
        element: ZikrForm,
      },
      {
        path: "edit/:id/:language",
        element: ZikrForm,
      },
      {
        path: "edit/:id",
        element: ZikrForm,
      },
    ],
  },
];
